<template>
  <div class="thirdPage" :style="{height:screenHeight}">
    <div class="thirdPage-title" :class="activeShow===3?'animate__animated animate__bounceInUp':''">
      <span>365跑腿</span> <font class="font2021">2022</font><span>全新展望</span>
    </div>
    <div class="thirdPage-desc" :class="activeShow===3?'animate__animated animate__bounceInUp':''">
      <span>省心便捷新时尚，优质生活心向往</span>
    </div>
    <div class="thirdPage-swiper margin-top-10" :class="ishide===1?'thirdPage-swiper-fadeio':0">
      <v-touch @swipeleft="swiperTouch('left')" @swiperight="swiperTouch('right')">
        <van-row type="flex" justify="space-around">
          <van-col span="11" v-if="activeIndex===0" style="position: relative">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/thirdCard1.png" style="width:100%;" class="thirdImg">
            <span class="thirdPage-swiper-desc">已为<font class="thirdPage-swiper-number">320万</font>用户解决合同文件、贵重物品等紧急递送难题，鲜花蛋糕速递<font class="thirdPage-swiper-number">稳居前三</font></span>
            <span class="thirdPage-swiper-tag">320万</span>
          </van-col>
          <van-col span="11" v-if="activeIndex===0" style="position: relative">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/thirdCard2.png" style="width:100%;" class="thirdImg">
            <span class="thirdPage-swiper-desc">已在全国<font class="thirdPage-swiper-number">74个</font>城市开通服务,即可享受365跑腿为您带来的便捷与贴心</span>
            <span class="thirdPage-swiper-tag">74个</span>
          </van-col>
          <van-col span="11" v-if="activeIndex===1" style="position: relative">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/thirdCard3.png" style="width:100%;" class="thirdImg">
            <span class="thirdPage-swiper-desc">平台骑手<font class="thirdPage-swiper-number">120万</font>运力充足，保证接单速度，一对一急送，拒绝拼单，保证物品及时送达</span>
            <span class="thirdPage-swiper-tag">120万</span>
          </van-col>
          <van-col span="11" v-if="activeIndex===1" style="position: relative">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/thirdCard4.png" style="width:100%;" class="thirdImg">
            <span class="thirdPage-swiper-desc">既然选择给您最好的，便只顾风雨兼程<font class="thirdPage-swiper-number">365个</font>日日夜夜，想给你每时每刻的守护心</span>
            <span class="thirdPage-swiper-tag">365个</span>
          </van-col>
        </van-row>
      </v-touch>
    </div>
    <div class="indicat">
      <ul style="width:60px;">
        <li v-for="(item,index) in 2" :key="index" :class="index===activeIndex?'active':''" @click="changeSwipe(index)"></li>
      </ul>
    </div>
    <div class="thirdVedio width100 float-left">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/pc/mp4/background.gif" style="width:96%;margin-left:2%;" :class="activeShow===3?'animate__animated animate__bounceIn':''">
      <span class="thirdVedio-title width100 float-left margin-top-15" :class="activeShow===3?'animate__animated animate__bounceIn':''">既然选择给你最好的，便只顾风雨兼程</span>
      <span class="thirdVedio-desc width100 float-left margin-top-5" :class="activeShow===3?'animate__animated animate__bounceIn':''">365个日日夜夜，想给你每时每刻的守护</span>
    </div>
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down_arrow.png" class="downButton" @click="moveSectionDown" style="margin-top:3% !important;">
    </div>
  </div>
</template>

<script>
export default {
  name: 'thirdPage',
  data(){
    return {
      screenHeight:0,
      screenWidth:0,
      activeIndex:0,
      ishide:0,
    }
  },
  props: {
    activeShow: Number
  },
  mounted(){

  },
  created(){
    this.screenHeight = document.documentElement.clientHeight+'px';
    this.screenWidth = document.documentElement.clientWidth+'px';
  },
  methods:{
    test(){
      console.log(123);
    },
    // 翻页方法 子传父
    moveSectionDown(){
      this.$emit('moveSectionDown');
    },
    // 切换焦点图
    changeSwipe(index){
      this.ishide = 1;
      setTimeout(()=>{
        this.activeIndex = index;
      },300)
      setTimeout(()=>{
        this.ishide = 0;
      },600)
      return false;
    },
    // 手势滑动方法
    swiperTouch(direction){
      // 设置页数最大值
      var max = 1;
      var min = 0;
      // 左滑方法
      if(direction==='left'){
        if(this.activeIndex+1>max||this.activeIndex+1<min){
          this.changeSwipe(min);
        }else{
          this.changeSwipe(this.activeIndex+1);
        }
      }
      // 右滑方法
      else if(direction==='right'){
        if(this.activeIndex-1>max||this.activeIndex-1<min){
          this.changeSwipe(max);
        }else{
          this.changeSwipe(this.activeIndex-1);
        }
      }
    }
  }
}
</script>
<style>
  /*iphone5样式适配*/
  @media (max-height: 569px){
    .thirdVedio{margin-top:5px !important;}
    .thirdPage-title span{font-size: 1.2em !important;}
    .font2021{font-size:1.5em !important;}
    .thirdVedio-title{margin-top:5px !important;font-size: 1em !important;}
    .thirdPage-title{padding-top:12% !important;}
    .thirdPage-swiper-tag{top:35%;}
    .thirdPage .indicat{margin-top:5px !important;}
    .thirdVedio-desc{font-size:0.8em;}
  }
  /*iphoneX样式适配*/
  @media (min-height: 737px) and (max-height: 820px){
    .thirdVedio{margin-bottom:30px;}
    .thirdPage-title{padding-top:18% !important;}
    .thirdPage-swiper{margin-top:30px !important;}
    .thirdPage .indicat{margin-bottom:20px;}
  }
</style>
